Page myPage
	title = "Meine Auktionen"
	showFor = [PrivateSeller, BusinessSeller, Business, Admin]
	needsAuth = true
	
	DatabaseTable<Good>	myGoods = {"goods"}
	
	show: string id = ""
		if not app.isLoggedIn then app.navigateTo loginPage; return
		html.setTitle title + app.titleSuffix
		await myGoods.fetch "seller = '{app.user.id}' || buyer = '{app.user.id}'" sort:"-updated"
		// if myGoods.length == 0: editPage.createAndNavigateToNewGood

	tick
		if myGoods.length > 0 then refresh
	
	draw
		if myGoods.length == 0
			column margin:{top:20 bottom:20} alignItems:center, gap:24
				div "Fahrzeuge, die Sie kaufen oder verkaufen, erscheinen auf dieser Seite.", fontSize:22
				app.button "Neues Inserat", onClick: editPage.createAndNavigateToNewGood			
		else
			row justifyContent:end margin:{top:20 bottom:20}
				app.button "Neues Inserat", onClick: editPage.createAndNavigateToNewGood
			column gap:style.gapBetweenBoxes
				for myGoods
					app.drawGoodBox .
